import React, { useContext } from "react"

import { InputContext } from "../../Input"
import { ColorInputContext } from "../context/ColorInputContext"

export const ReadonlyColor = React.memo(() => {
  const { readonly } = useContext(InputContext)
  const { colors } = useContext(ColorInputContext)

  if (!readonly) return null

  return (
    <div className="color-input__readonly">
      {colors.map(color => (
        <div
          key={color.value}
          className="color-input__readonly-swatch"
          style={{ backgroundColor: color.value }}
          title={color.label || color.value}
        />
      ))}
    </div>
  )
})

ReadonlyColor.displayName = "ReadonlyColor"
